import BaseService from "@/services/BaseService";

export default class ShareModelDescriptionService extends BaseService {
  constructor() {
    super('insurance_pricing/share_models');
  }

  findAll(shareModelId) {
    return this.http.get(`${this._serviceName}/${shareModelId}/descriptions`);
  }

  save(shareModelId, data) {
    return this.http.post(`${this._serviceName}/${shareModelId}/descriptions`, data);
  }
}
